import React, { useEffect, useState } from "react";
import { DropBox } from "../../../components";
import { getLanguage } from "../../../utils/environment";
import { useDispatch } from "react-redux";
import {
  getAllAdvCategory,
  getAllAdvSubCategory,
} from "../../CreateNewItem/CreateNewAdvertisement/service/advertisement.service";
import { setAdvCategoryList } from "../../advertisement/redux/actions";

const lan = getLanguage();

const Index = ({ data, onChangeCategory }) => {
  const [language, setLanguage] = useState("");
  const [formData, setFormData] = useState({
    category: {
      key: "category",
      label: "Category",
      size: "lg",
      placeholder: "Select category",
      mainLayerStyles: " flex-column align-content-center mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);

  const fetchAdvCategory = async () => {
    const updateForm = { ...formData };
    if (updateForm.category.elementConfig.options.length > 0) {
      return;
    }
    updateForm.category.loading = true;
    updateForm["category"].elementConfig.options = [];
    const response = await getAllAdvCategory();
    console.log("Sub Category Response:", response);
    if (response?.data) {
      let categoryList = [];
      if (data.type === "superCategory") {
        categoryList = await syncAdvSupCategory(response.data);
        updateForm["category"].elementConfig.options = categoryList;
        updateForm.category.loading = false;
        setFormData(updateForm);
      }
      console.log("Category List:", categoryList);

      // dispatch(setAdvCategoryList(response.data));
    }
  };

  const fetchAdvSubCategory = async () => {
    const updateForm = { ...formData };
    if (updateForm.category.elementConfig.options.length > 0) {
      return;
    }
    updateForm.category.loading = true;
    updateForm["category"].elementConfig.options = [];
    const response = await getAllAdvSubCategory();
    console.log("Sub Category Response:", response);
    if (response?.data) {
      let categoryList = [];
      if (data.type === "subCategory") {
        categoryList = await syncAdvSubCategory(response.data);
        updateForm["category"].elementConfig.options = categoryList;
        updateForm.category.loading = false;
        setFormData(updateForm);
      }
      console.log("Category List:", categoryList);
      // dispatch(setAdvCategoryList(response.data));
    }
  };

  const syncAdvSubCategory = async (res) => {
    let categoryList = [];
    for (let category of res) {
      categoryList.push({
        id: category.category_id,
        key: category.sub_category_id,
        value: category.sub_category_id,
        displayValue: category.sub_category_name,
        // options: await syncAdvSubCategorySub(category.sub_category),
      });
    }
    return categoryList;
  };

  // const syncAdvSubCategorySub = async (res) => {
  //   let categoryList = [];
  //   for (let category of res) {
  //     categoryList.push({
  //       id: category.sub_category_id,
  //       label: category.sub_category_name,
  //       value: category.sub_category_id,
  //       displayValue: category.sub_category_name,
  //     });
  //   }
  //   return categoryList;
  // };

  const syncAdvSupCategory = async (res) => {
    let categoryList = [];
    for (let category of res) {
      categoryList.push({
        id: category.category_id,
        key: category.category_name,
        value: category.category_id,
        displayValue: category.category_name,
      });
    }
    return categoryList;
  };

  useEffect(() => {
    if (data.type === "superCategory") {
      fetchAdvCategory();
    }
    if (data.type === "subCategory") {
      fetchAdvSubCategory();
    }
  }, [data]);

  const updateNewsForm = { ...formData };

  return (
    <>
      {/* {data.type === "superCategory" && ( */}
      <DropBox
        data={updateNewsForm.category}
        onChange={(e, value) => {
          const updateForm = { ...formData };
          updateForm["category"].value = e;
          setFormData(updateForm);
          let categoryList = updateForm.category.elementConfig.options;
          let selectedCategory = categoryList.find(
            (category) => category.value === e
          );
          console.log("Category Select Box:", e, selectedCategory);
          if (data.type === "subCategory") {
            onChangeCategory(selectedCategory);
          } else {
            onChangeCategory(e);
          }
        }}
      />

      {/* {data.type === "subCategory" && (
        <>
          <div className={`txt-label`}>
            Category
            <b> *</b>
          </div>
          <Select
            style={{ width: "100%" }}
            onChange={(e, value) => {
              const updateForm = { ...formData };
              updateForm["category"].value = e;
              setFormData(updateForm);
              console.log("Category Select Box:", e, value);
              onChangeCategory(e);
            }}
            options={options}
          />
        </>
      )} */}
    </>
  );
};

export default Index;
